export const IDLE_DELAY = 10 * 60 * 1000

export function createIdlePolicy(now: () => number, onIdle: () => void) {
  let lastActive = now()
  let handled = false
  return {
    touch() { lastActive = now(); handled = false },
    check() {
      if (!handled && now() - lastActive >= IDLE_DELAY) {
        handled = true
        onIdle()
      }
      return Math.max(0, IDLE_DELAY - (now() - lastActive))
    },
  }
}
